import React from 'react';
import { connect } from 'react-redux';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { usersLoginsConfigs } from '../../entity/designations/usersLoginsConfigs';
import BaseComponent from '../../components/BaseComponent';

class UserLogins extends BaseComponent {
  constructor(props: any) {
    super(props);
    this.config = { ...usersLoginsConfigs };
    this.getResponse();
  }
}

const mapStateToProps = (state: {
  app: { isAuthenticated: any; user: any };
}) => ({
  isAuthenticated: state.app.isAuthenticated,
  user: state.app.user,
});

const UserLoginsWrapper = (props: any) => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  return (
    <UserLogins
      {...props}
      navigate={navigate}
      location={location}
      params={params}
    />
  );
};

export default connect(mapStateToProps)(UserLoginsWrapper);
